import Clarity from '@microsoft/clarity';
import envConfig from 'configs/envConfig';

const projectId = envConfig('microsoftClarityProjectId');

export const enableClarity =
  envConfig('env') === 'prod' ||
  envConfig('env') === 'luna' ||
  envConfig('env') === 'staging' ||
  envConfig('env') === 'luna-stg';

if (projectId && enableClarity) Clarity.init(projectId);
